import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import resolvePath from '../../misc/resolvePath';
import CommunityAgenda from '../screens/CommunityAgenda';
import CommunityItemEventScreen from '../screens/CommunityItemEventScreen/CommunityItemEventScreen';
import SubEventHomeScreen from '../screens/EventHomeScreen/SubEventHomeScreen';

export default (props) => (
    <Switch>
        <Redirect from="/events/:communityId/agenda/subevent" to="/events/:communityId/agenda" exact />
        <Route path="/events/:communityId/agenda/item/:eventId" exact component={CommunityItemEventScreen} />
        <Route path="/events/:communityId/agenda/subevent/:eventId" exact component={SubEventHomeScreen} />
        <Route path="/events/:eventId/agenda" exact component={CommunityAgenda} />
        <Redirect to={resolvePath(location.pathname, '..')} />
    </Switch>
);
